export default {
      id: "leftshoulder-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#leftshoulder",
      toString: function () {
        return this.url;
      }
    }